import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = ['audioDownloadUpgradeClick', 'audioUpgradeModalShown', 'audioUpgradeChoosePlanModalClick'] as const;

export const audioDownloadEvents = getMappedEvents([...EVENTS], {
  shouldSendRaskTTSData: true,
  shouldSendSubscriptionData: true,
});
